import { Component, Input } from '@angular/core';

import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-round-badge',
    imports: [MatTooltipModule],
    templateUrl: './round-badge.component.html',
    styleUrls: ['./round-badge.component.scss']
})
export class RoundBadgeComponent {
  @Input() visible: boolean = true;
  @Input() badgeText: string = '';
  @Input() tooltipText: string = '';
  @Input() backgroundColor: string = 'DimGray';
}
